import 'regenerator-runtime/runtime';
import { Measure } from '@cbsi-cbscom/measure';
import { setupPlayerServicesNamespace } from 'library/ts/namespaces/PlayerServices';
import { Metrics } from 'library/ts/utilities/measure/Metrics';
import { initializePolyfills } from 'library/ts/utilities/Polyfill';
import { SmartTag } from 'tag/ts/smart_tag/SmartTag';
Measure.start(Metrics.importToCreateTime);
initializePolyfills();
setupPlayerServicesNamespace()
    .then((namespace) => {
    window.SmartTag = window.SmartTag || new SmartTag(namespace);
});
